import { Button as HeadlessButton } from '@headlessui/react';
import cls from './button.module.scss';
import { Loader } from 'shared/ui/loader/loader';

type ButtonTheme = 'filled' | 'tonal' | 'outlined' | 'text';

type ButtonTone = 'default' | 'danger' | 'warning' | 'info' | 'success';

type ButtonShape = 'round' | 'square' | 'sharp' | 'soft';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  theme?: ButtonTheme;
  tone?: ButtonTone;
  style?: React.CSSProperties;
  size?: 'xs' | 's' | 'm';
  shape?: ButtonShape;
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = props => {
  const {
    children,
    title,
    className,
    onClick,
    style,
    theme = 'clean',
    size = 's',
    tone,
    shape = 'round',
    type,
    disabled = false,
    loading = false,
    ...rest
  } = props;
  const classes = [
    cls.button,
    cls[theme],
    tone ? cls[tone] : '',
    cls[size],
    cls[shape],
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <HeadlessButton
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      title={title}
      style={style}
      className={classes}
      {...rest}
    >
      {loading && <Loader size={16} color='currentColor' />}
      {children}
    </HeadlessButton>
  );
};

export default Button;
